import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { byValue, occurrence } from '@Containers/ResultsFilters/ResultsFiltersConstants';
import { RadioButtonGroup } from '@els/els-react--radio-button';
import SortingDropdown from '@Containers/ResultsFilters/ResultsFiltersComponents/SortingDropdown';
import ClearSelectedButton from './ClearSelectedButton';
import SortingButtons from './SortingButtons';
import { sortingOptionsTypeMap } from '../BarChartCheckboxesDialogConstants';
import SelectedItemsCount from '../../SelectedItemsCount';

import './BarChartCheckboxesDialogHeader.scss';

function BarChartCheckboxesDialogHeader(props) {
  const {
    filterTitle,
    selectedCount,
    customGroups,
    customGroupsRadioButtonsFeatureEnabled,
    sortingType,
    onClickClearSelected,
    onOccurrence,
    onByValue,
  } = props;
  const showCustomGroupsRadioButtons = !!customGroups && customGroupsRadioButtonsFeatureEnabled;

  return (
    <>
      <h2 className="bar-chart-checkboxes-dialog-header-title" id="dialog-title">
        {filterTitle}
      </h2>
      <hr className="u-els-margin-top-1o2 bar-chart-checkboxes-header-divider" />
      {!showCustomGroupsRadioButtons && (
        <div className="bar-chart-checkboxes-dialog-header-controls-wrapper u-els-margin-top u-els-margin-bottom">
          <section className="section-left">
            <section>
              <SelectedItemsCount count={selectedCount} showZero />
              <span className={classnames('selected-items-count-label', 'u-els-margin-left-1o4')}>selected</span>
            </section>
            <ClearSelectedButton {...props} />
          </section>
          <section className="section-right">
            <SortingDropdown
              sortingType={sortingType}
              onOccurrence={onOccurrence}
              onByValue={onByValue}
              onClickClearSelected={onClickClearSelected}
            />
            <SortingButtons {...props} />
          </section>
        </div>
      )}
      {showCustomGroupsRadioButtons && (
        <div className="bar-chart-checkboxes-dialog-header-controls-wrapper u-els-margin-top u-els-margin-bottom">
          <section className="section-left">
            <SelectedItemsCount count={selectedCount} showZero />
            <span className="bar-chart-checkboxes-dialog-header-selected">selected</span>
            <ClearSelectedButton {...props} />
            <SortingButtons {...props} />
          </section>
          <section className="section-right">
            <RadioButtonGroup
              isInline
              options={[sortingOptionsTypeMap[occurrence], sortingOptionsTypeMap[byValue]]}
              onChange={(t) => {
                if (t.target.value === sortingOptionsTypeMap[occurrence]) {
                  onOccurrence();
                } else if (t.target.value === sortingOptionsTypeMap[byValue]) {
                  onByValue();
                }
                onClickClearSelected();
              }}
              value={sortingType && sortingOptionsTypeMap[sortingType]}
              a11y={{ name: 'Sort by:' }}
            />
          </section>
        </div>
      )}
    </>
  );
}

BarChartCheckboxesDialogHeader.propTypes = {
  filterTitle: PropTypes.string.isRequired,
  onClickClearSelected: PropTypes.func.isRequired,
  onAscending: PropTypes.func.isRequired,
  onDescending: PropTypes.func.isRequired,
  disableAscending: PropTypes.bool.isRequired,
  disableDescending: PropTypes.bool.isRequired,
  onByValue: PropTypes.func.isRequired,
  onOccurrence: PropTypes.func.isRequired,
  sortingType: PropTypes.oneOf([occurrence, byValue]).isRequired,
  customGroups: PropTypes.bool,
  selectedCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  customGroupsRadioButtonsFeatureEnabled: PropTypes.bool,
  activeChunk: PropTypes.array,
};

export default BarChartCheckboxesDialogHeader;
